var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-info"},[_c('span',{staticClass:"star"},[_vm._v("*")]),_vm._v(" "+_vm._s(this.info)+" "),(_vm.date.month)?_c('span',[_c('span',{staticClass:"month"},[_vm._v(_vm._s(this.date.month))])]):_vm._e(),(_vm.date.year)?_c('span',[_c('span',{staticClass:"year"},[_vm._v(_vm._s(this.date.year))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }